import { makeRequest } from 'utils/requestLogger';

export default (file, folder_name) => {
  const formData = new FormData();
  formData.append('folderName', folder_name);
  formData.append('file', file);

  return makeRequest('post', '/api/files/upload', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};



// WEBPACK FOOTER //
// ./src/app/services/amazonAWS/postFileToS3.js